<template>
  <div>
    <ul class="ul-list-none">
      <router-link
        v-for="actionPermission in actionPermissions"
        :key="actionPermission.id"
        tag="li"
        active-class="active"
        :to="link(actionPermission.menu)"
        :title="actionPermission.name"
      >
        <a href="#">
          {{ actionPermission.name }}
        </a>
        <span
          v-if="actionPermission.id == 15 && notifications.count > -1"
          class="notification-count"
          @click="showNotification"
        >
          {{  notifications.count  }}
        </span>
      </router-link>
    </ul>
    <Notification
      :notifications="notifications"
    />
  </div>
</template>

<script>
import User from '@/model/user'
import { Trans } from "@/plugins/Translation"
import { mapGetters } from 'vuex'
import Notification from '@/components/widget/Notification.vue'

export default {
  components: {
    Notification
  },

  data() {
    return {
      actionPermissions: null
    }
  },
  watch: {
    $route: 'fetchData'
  },
  created() {
    this.fetchData()
  },

  computed: {
    ...mapGetters({
      notifications: 'getNotifications'
    })
  },

  methods: {
    showNotification () {
      this.$store.dispatch('notificationActive', true)
    },

    fetchData() {
      User.getActionPermissionsByType('menu').then((response) => {
        this.actionPermissions = response.data
      })
    },
    link(menu) {
      switch (menu.view.view) {
        case 'url':
          return Trans.currentLocaleUrl + '/' + menu.url
        default:
          return '#'
      }
    }
  }
}
</script>
<style lang="scss">
  .ul-list-none {
      display: flex !important;
      position: relative;

      .notification-count {
        position: absolute;
        margin-left: 180px;
        top: -10px;
        display: block;
        background-color: #f9b656;
        border-radius: 20px;
        width: 30px;
        height: 30px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        line-height: 30px;
        color: #fff;
        cursor: pointer;
      }
  }
</style>
